import jQuery from 'jquery';
import {cartIsEmpty} from '../services/cartService'
import {isCurrentPointOfService} from '../services/pointOfServicesService';
import stringInject from 'stringinject';


const dataAttr = 'data-change-pos-widget';

const shouldNavigateToPointOfService = function(posCode, posName, triggerElm){
	const dfd  = jQuery.Deferred();
	if(cartIsEmpty() || isCurrentPointOfService(posCode)){
		dfd.resolve(true);
	}else{
		const changePosText = stringInject(__('change-pos-widget.message'), {posName: posName});
		const confirmLabel = __('change-pos-widget.confirm');
		const cancelLabel = __('change-pos-widget.cancel');
		const overlayContent = jQuery('<div class="change-pos-widget-content"><div class="change-pos-text">' + changePosText + '</div><div class="change-pos-buttons"><button type="button" class="cancel-change-pos-btn">' + cancelLabel + '</button><button type="button" class="change-pos-btn">' + confirmLabel + '</button></div></div>');

		let accepted = false;
		const acceptedListener = function(){
			accepted = true;
			$.ep.overlayWidget.close();
		}
		
		const cancelListener = function(){
			$.ep.overlayWidget.close();
		}
		
		const changePosBtn = overlayContent.find('.change-pos-btn');
		const cancelChangePosBtn = overlayContent.find('.cancel-change-pos-btn');

		changePosBtn.on('click', acceptedListener);
		cancelChangePosBtn.on('click', cancelListener);

		const options = {
			title:  __('change-pos-widget.title'),
			content: overlayContent,
			maxWidth: '95%',
			maxHeight: '90%',
			height: 'auto',
			width: '500px',
			listeners: {
				onClose: () => {
					changePosBtn.off('click', acceptedListener);
					cancelChangePosBtn.off('click', cancelListener);
					dfd.resolve(accepted);
				}
			}
		};

		$.ep.overlayWidget.mount(options, triggerElm);
	}
	
	return dfd.promise();
}

export default function(){
	jQuery(function(){
		jQuery('body').on('click', '[' + dataAttr + ']', function(event){
			const elm = jQuery(this);
			const posCode = elm.attr(dataAttr + '-code');
			const posName = elm.attr(dataAttr + '-name');
			
			event.preventDefault();
			shouldNavigateToPointOfService(posCode, posName, elm)
				.then(function(shouldNavigate){
					if(shouldNavigate){
						window.location = elm.attr('href');
					}
				});
		});
	});
}